import { createRouter, createWebHistory } from 'vue-router'
import Upload from '../views/Upload.vue'
import ViewReport from '../views/ViewReport.vue'
import PdfViewer from '../views/PdfViewer.vue'
import ReportList from '../views/ReportList.vue'
import Login from '../views/Login.vue'
import Home from '../views/website/Home.vue'
import About from '../views/website/About.vue'
import News from '../views/website/News.vue'
import NewsDetail from '../views/website/NewsDetail.vue'
import Services from '../views/website/Services.vue'
import Detection from '../views/website/Detection.vue'
import { hasPermission } from '../utils/auth.js'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { 
      requiresAuth: false,
      title: '山东文达检测'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { 
      requiresAuth: false,
      title: '关于我们'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: { 
      requiresAuth: false,
      title: '新闻资讯'
    }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetail,
    props: true,
    meta: { 
      requiresAuth: false,
      title: '新闻详情'
    }
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta: { 
      requiresAuth: false,
      title: '我们的服务'
    }
  },
  {
    path: '/testing-center',
    name: 'Detection',
    component: Detection,
    meta: { 
      requiresAuth: false,
      title: '检测中心'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { 
      requiresAuth: false,
      title: '登录'
    }
  },
  {
    path: '/ReportList',
    name: 'ReportList',
    component: ReportList,
    meta: { 
      requiresAuth: true,
      title: '报告列表'
    }
  },
  {
    path: '/upload',
    name: 'Upload',
    component: Upload,
    meta: { 
      requiresAuth: false,
      title: '上传报告'
    }
  },
  {
    path: '/edit/:id',
    name: 'EditReport',
    component: Upload,
    props: true,
    meta: { 
      requiresAuth: false,
      title: '编辑报告'
    }
  },
  {
    path: '/view/:id',
    name: 'ViewReport',
    component: ViewReport,
    props: true,
    meta: { 
      requiresAuth: false,
      title: '查看报告'
    }
  },
  {
    path: '/pdf-viewer/:id',
    name: 'PdfViewer',
    component: PdfViewer,
    props: true,
    meta: { 
      requiresAuth: false,
      title: '文档预览'
    }
  },
  {
    path: '/reports',
    redirect: '/ReportList'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    // http://119.45.115.199/view/519b0175-a6dc-4169-add2-b109aa439791
    if(to.name === 'ViewReport'){
      document.title = '查看报告 — 检验报告管理系统'
    }
    else if(to.name === 'ReportList'){
      document.title = '报告列表 — 检验报告管理系统'
    }
    else if(to.name === 'Login'){
      document.title = '登录 — 检验报告管理系统'
    }
    else{
      document.title = `${to.meta.title} - 山东文达检测`
    }
    
  }
  
  // 检查路由是否需要认证
  if (to.meta.requiresAuth) {
    // 需要认证的路由
    if (hasPermission()) {
      next()
    } else {
      // 未登录，跳转到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    // 不需要认证的路由
    if (to.path === '/login' && hasPermission()) {
      // 已登录用户访问登录页，重定向到报告列表页
      next({ path: '/ReportList' })
    } else {
      next()
    }
  }
})

export default router